import * as moment from 'moment';

import { TimeUnit, DayOfWeek } from '../../../models';
import { alignProperty } from './alignProperty';
import { IAlignmentStrategy } from './IAlignmentStrategy';

export class MinuteAlignmentStrategy implements IAlignmentStrategy {
    align(input: moment.Moment, beginTime: moment.Duration, interval: number, intervalTimeUnit: TimeUnit,
        dayOfWeek: DayOfWeek): moment.Moment {
        let result: moment.Moment = null;
        if (intervalTimeUnit === TimeUnit.Minute) {
            result = input.clone();

            let newMinutes = beginTime.minutes();
            let origMinutes = result.minutes();
            const alignedSeconds = alignProperty(input.seconds(), 0);
            origMinutes += alignedSeconds.additional;

            if (origMinutes < beginTime.minutes()) {
                while (newMinutes > origMinutes) {
                    newMinutes -= interval;
                }
            }
            while (newMinutes < origMinutes) {
                newMinutes += interval;
            }
            result = result.minutes(newMinutes)
                .seconds(beginTime.seconds())
                .milliseconds(beginTime.milliseconds());
        }
        return result;
    }
}
